<div class="sidenav-menu">
  <!-- User Profile - Sticky at top -->
  @if (layout.sidenavUser) {
    <div class="sidenav-user-wrapper">
      <app-user-profile />
    </div>
  }

  <!-- Scrollable Menu Section -->
  <div class="sidenav-menu-wrapper" [class.is-scrolled]="isScrolled()" #menuWrapper>
    <ngx-simplebar id="sidenav" class="scrollbar">
      <app-menu />
    </ngx-simplebar>
  </div>

  <div class="sidenav-footer">
    <p class="sidenav-version" aria-label="Application version">{{ appVersion }}</p>
  </div>
</div>
